import { Component, OnInit, EventEmitter } from '@angular/core';
import { TableConfiguration, TableColumns, HttpService, SessionService, MessageService, params, LocalStorageService, MenuBreadCrumb } from 'brainloper-ui';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { Area } from 'src/app/models/administration/area';


@Component({
    selector: 'areas',
    templateUrl: './areas.component.html',
    styleUrls: ['./areas.component.scss'],
    standalone: false
})
export class AreasComponent implements OnInit {

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
      name:"Areas",
      current:true
    }
  ]

  public urlGetDatosAreas:string = `${EndpointDictionary.Area.AREA_TABLE}`
  private urlAreasDetalle:string = `${EndpointDictionary.Area.CRUD_AREA_DATA}`
  private id_compania:number

  public params: params[]

  public recargarTablaAreas = new EventEmitter<any>()
  public configurationAreas : TableConfiguration = {
      edit:true,
      add:true,
      delete:true,
      selectable:true,
      addPer:true,
      editPer:true,
      primaryKey:'id'
    }
  public columnasAreas : TableColumns<any>[]
  constructor(
    private http: HttpService,
    private session: SessionService,
    private message: MessageService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private deleteItem: DeleteGenericService,
    private storage : LocalStorageService
  ) {
    this.params = [
    {
      id:'id_compania',
      value: this.storage.get<number>('id_compania')
    }]
    this.id_compania = this.storage.get<number>('id_compania')
    this.columnasAreas = [
    {
      ID: 'nombre',
      label: 'Nombre',
      type: 'text',
      style: {

      }
    },
    {
      ID: 'responsable',
      label: 'Responsable',
      type: 'combo',
      style: {

      },
      paramsCombo: {
        selectionField: 'cedula',
        visibleField: 'nombre',
        urlParams:[{id:'id_compania', value:`${this.storage.get<number>('id_compania')}`}],
        url: `${environment.endpoint}${EndpointDictionary.User.USER_COMBO}`,
       }
    },
    {
      ID: 'codigo',
      label: 'Codigo',
      type: 'text',
      style: {

      }
    },
    {
      ID: 'descripcion',
      label: 'Descripción',
      type: 'text',
      style: {

        movil: 'no-movil'
      }
    },
  ]

  }

  ngOnInit(): void {
  
  }

  agregarAreas($event){

    this.session.setData('redireccion', 'nuevo')
    this.router.navigate(['detalle'], { relativeTo: this.activeRoute })


  }

  editarAreas($event){
      ////console.log($event)

     this.http.getData( `${this.urlAreasDetalle}/${$event[0]['id']}`).subscribe(
       (res: BaseResponse<Array<Area>>)=>{
         if(res['code']===0){

          this.session.setData('dataArea', res['body'])
          this.session.setData('redireccion', 'actualizar')
          this.router.navigate(['detalle'], {relativeTo: this.activeRoute} )


         }else{
          this.message.Error('Error!', `Codigo:${res['code']} - Mensaje: ${res['message']}`)
         }
       },
       err=>{
        this.message.Error('Error!',err['message'])
       }
     )
 }

  seleccionadosAreas($event){
     // //console.log($event)
  }

  clickFilaAreas($event){
    ////console.log($event)

    this.http.getData( `${this.urlAreasDetalle}/${$event['id']}`).subscribe(
      (res: BaseResponse<Array<Area>>) =>{
        if(res['code']===0){

         this.session.setData('dataArea', res['body'])
         this.session.setData('redireccion', 'actualizar')
         this.router.navigate(['detalle'], {relativeTo: this.activeRoute} )


        }else{
         this.message.Error('Error!', `Codigo:${res['code']} - Mensaje: ${res['message']}`)
        }
      },
      err=>{
       this.message.Error('Error!',err['message'])
      }
    )
  }

  async eliminarAreas($event) {

    let res =  await this.deleteItem.deleteD($event, this.urlAreasDetalle, "id", "Area", "Areas")
          this.recargarTablaAreas.emit()
  }

}
